import React from "react";
import { useNavigate } from "react-router-dom";

const ReunionCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 px-6 bg-gradient-to-br from-emerald-950 via-teal-950 to-purple-950 overflow-hidden">

      {/* Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(at_20%_20%,rgba(16,185,129,0.15),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(at_80%_70%,rgba(147,51,234,0.12),transparent_60%)]"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">

        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 px-6 py-2 rounded-full mb-6">
          <span className="text-xl">🎉</span>
          <span className="uppercase tracking-[0.3em] text-xs font-semibold text-emerald-200">
            Ready to Celebrate?
          </span>
        </div>

        <h2 className="text-3xl lg:text-5xl font-black text-white leading-tight mb-6">
          Turn Every Gathering
          <br />
          Into an Unforgettable Reunion.
        </h2>

        <p className="max-w-3xl mx-auto text-sm lg:text-lg text-emerald-100/90 leading-relaxed mb-3">
          Whether it's a housing society event, corporate meeting, birthday,
          school reunion, college festival, family gathering or community
          celebration, Reunion makes participation simple, engaging and
          memorable for everyone.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-3">

          <button
            onClick={() => navigate("/reunion/organisor-dashboard")}
            className="w-72 lg:w-auto px-6 py-3 rounded-xl font-semibold bg-gradient-to-r from-emerald-500 to-green-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-emerald-500/30"
          >
            🎤 Organizer Dashboard
          </button>

          <button
            onClick={() => navigate("/reunion/play")}
            className="w-72 lg:w-auto px-6 py-3 rounded-xl font-semibold bg-gradient-to-r from-violet-500 to-purple-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-violet-500/30"
          >
            ▶️ Join & Play
          </button>

        </div>

        {/* Bottom Quote */}
        <div className="mt-12">

          <div className="text-5xl mb-4">🫂</div>

          <p className="text-lg lg:text-2xl font-bold text-white">
            Celebrate • Connect • Compete
          </p>

          <p className="mt-3 text-sm lg:text-base text-emerald-200/80">
            Powered by <span className="font-semibold">Think5Whys</span> •{" "}
            <span className="font-semibold">PurpleDoor</span> •{" "}
            <span className="font-semibold">Reunion</span>
          </p>

        </div>

      </div>
    </section>
  );
};

export default ReunionCTA;